import { Category } from "../../configuration/navMenuConfiguration";
import { Box, ListItem, ListItemText } from "@mui/material";

type NavMenuCategoryProps = {
  category: Category;
};

export default function NavMenuCategory(props: NavMenuCategoryProps) {
  return (
    <ListItem
      disablePadding
      key={props.category.id}
      sx={{
        gap: "8px",
        padding: "8px 0px",
      }}
      data-testid={"nav-menu-category"}
    >
      <Box sx={iconContainerSx}>
        <i className={props.category.icon} />
      </Box>
      <ListItemText
        primary={props.category.label}
        sx={{ margin: 0 }}
        primaryTypographyProps={{ style: { fontWeight: 600 } }}
      />
    </ListItem>
  );
}

const iconContainerSx = {
  width: "24px",
  height: "24px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};
